import PriceBreakDown from 'components/receipt/PriceBreakDown';
import React from 'react';
import { ParkingPrice } from 'types/generatedSchemaTypes';
import { SalesOrderReceipt } from './SalesOrderReceiptClass';

const PermitPaymentInfo = ({
  salesOrderReceipt,
  isHistory,
  isSubscription,
}: {
  salesOrderReceipt: SalesOrderReceipt;
  isHistory: boolean;
  isSubscription?: boolean;
}) => {
  const {
    countryCode,
    orderLines,
    vatPercent,
    created,
    billingItems,
    isFailedRecurringPaymentForSalesOrder,
    orderStatus,
  } = salesOrderReceipt || {};

  const orderLine = orderLines?.[0];

  const isHistoryCountry = isHistory
    ? salesOrderReceipt?.item?.countryCode
    : countryCode;

  const subMerchant = salesOrderReceipt?.subMerchant ?? null;

  let totalAmount = 0;
  let vatPercentage = 0;
  let vatAmount = 0;
  let permitFee = 0;
  let serviceFee = 0;
  if (orderLine) {
    vatPercentage = vatPercent ?? 0;
    vatAmount = (orderLine?.lineVatAmount || 0) / 100;
    totalAmount = (orderLine?.lineTotal || 0) / 100;
    serviceFee = (orderLine?.serviceFeeAmountWithoutVat || 0) / 100;
    permitFee = totalAmount - vatAmount - serviceFee;
  }

  const price = {
    __typename: 'ParkingPrice',
    breakdown: {
      parkingFee: {
        amountExclVAT: permitFee,
      },
      serviceFee: {
        amountExclVAT: 0,
      },
    },
    totalAmount: totalAmount,
    vatAmount: vatAmount,
    vatPercentage: vatPercentage,
    serviceFee: serviceFee,
  } as ParkingPrice;

  return (
    <PriceBreakDown
      orderStatus={orderStatus}
      paymentDate={created ? new Date(created) : undefined}
      price={billingItems || price}
      countryCode={isHistoryCountry || 'FI'}
      subMerchant={subMerchant}
      isPaymentFailed={isFailedRecurringPaymentForSalesOrder}
      isCompacted
      feeType={
        isSubscription
          ? 'account.aimoSubscription.subscriptionFee'
          : 'permit.permitFee'
      }
    />
  );
};

export default PermitPaymentInfo;
